<div class="game-stat" *ngIf="game && statistic">
  <div class="stats-values">
    <div class="stat-row">
      <div class="value">{{ statistic.team.shots || 0 }}</div>
      <div class="name">Броски</div>
      <div class="value">{{ statistic.competitorTeam.shots || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.shotsOnGoal || 0 }}</div>
      <div class="name">Броски в створ</div>
      <div class="value">{{ statistic.competitorTeam.shotsOnGoal || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.goalsPercent || 0 }}%</div>
      <div class="name">Процент реализации</div>
      <div class="value">{{ statistic.competitorTeam.goalsPercent || 0 }}%</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.penaltyGoals || 0 }}<span class="text-muted">/{{ statistic.team.penaltyShots || 0 }}</span></div>
      <div class="name">7м броски</div>
      <div class="value">{{ statistic.competitorTeam.penaltyGoals || 0 }}<span class="text-muted">/{{ statistic.competitorTeam.penaltyShots || 0 }}</span></div>
    </div>

    <div class="stat-row">
      <div class="value">{{ statistic.team.blockShots || 0 }}</div>
      <div class="name">Блоки</div>
      <div class="value">{{ statistic.competitorTeam.blockShots || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.steals || 0 }}</div>
      <div class="name">Перехваты</div>
      <div class="value">{{ statistic.competitorTeam.steals || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.turnovers || 0 }}</div>
      <div class="name">Потери</div>
      <div class="value">{{ statistic.competitorTeam.turnovers || 0 }}</div>
    </div>

    <div class="stat-row">
      <div class="value">{{ statistic.team.twoMinuteFouls || 0 }}</div>
      <div class="name">Удаления</div>
      <div class="value">{{ statistic.competitorTeam.twoMinuteFouls || 0 }}</div>
    </div>

    <div class="stat-row">
      <div class="value">{{ statistic.team.yellowCards || 0 }}</div>
      <div class="name">Желтые карточки</div>
      <div class="value">{{ statistic.competitorTeam.yellowCards || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.redCards || 0 }}</div>
      <div class="name">Красные карточки</div>
      <div class="value">{{ statistic.competitorTeam.redCards || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.saves || 0 }}</div>
      <div class="name">Сейвы вратарей</div>
      <div class="value">{{ statistic.competitorTeam.saves || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.savesPercent || 0 }}%</div>
      <div class="name">Процент сейвов</div>
      <div class="value">{{ statistic.competitorTeam.savesPercent || 0 }}%</div>
    </div>
  </div>
</div>
